import * as angular from 'angular';
import * as Widgets from '../widgets';

import { IPrintConfiguration } from '../services/helpers/printOptions.service';
import { WidgetBase } from '../widgets';
import { DashboardPeriod } from './enum';

export class DashboardConfiguration {
    dashboardName: string;
    defaultPeriod: DashboardPeriod;
    printConfiguration: IPrintConfiguration;
    referenceGroup?: string;
    type: string;
    widgets: Widgets.IWidget[];

    constructor() {
        this.printConfiguration = {} as IPrintConfiguration;
        this.printConfiguration.isUseNewPrintSystem = true;
    }

    static serialize(config: DashboardConfiguration): DashboardConfiguration {
        const configResult: DashboardConfiguration = {
            widgets: [],
            dashboardName: config.dashboardName,
            defaultPeriod: config.defaultPeriod,
            referenceGroup: config.referenceGroup,
            type: config.type,
            printConfiguration: angular.copy(config.printConfiguration)
        };
        if (config.widgets) {
            config.widgets.forEach((w: Widgets.WidgetBase) => {
                configResult.widgets.push(WidgetBase.serialize(w));
            });
        }
        return configResult;
    }

    static copy(config: DashboardConfiguration): DashboardConfiguration {
        const configuration = {
            dashboardName: config.dashboardName,
            defaultPeriod: config.defaultPeriod,
            printConfiguration: config.printConfiguration,
            referenceGroup: config.referenceGroup,
            type: config.type,
            widgets: []
        } as DashboardConfiguration;

        if (config && config.widgets) {
            config.widgets.forEach((widget: WidgetBase) => {
                const copiedWidget = WidgetBase.copy(widget);
                configuration.widgets.push(copiedWidget);
            });
        }

        return configuration;
    }
}